import { useEffect, useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import {
  Box,
  Typography,
  CircularProgress,
  Card,
  Stack,
  Avatar,
  Button,
} from "@mui/material";
import { EventContext } from "../../../contexts/EventContext";
import request from "../../../utilities/requests";

const Votes = () => {
  const navigate = useNavigate();
  const { pairingEvent } = useContext(EventContext);
  const [loading, setLoading] = useState(true);
  const [pitches, setPitches] = useState([]);

  const getVotes = async () => {
    if (!pairingEvent?.event?._id) return;

    try {
      setLoading(true);

      const result = await request(
        `pitchesadmin/votes?eventId=${pairingEvent?.event?._id}`,
      );

      if (result.success) {
        setPitches(result.pitches || []);
      }

      setLoading(false);
    } catch (e) {
      console.error(e);
      setLoading(false);
    }
  };

  useEffect(() => {
    getVotes();
  }, [pairingEvent]);

  if (loading) {
    return (
      <Box
        sx={{
          height: "60vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        <CircularProgress size={60} />
      </Box>
    );
  }

  if (!pitches.length) {
    return (
      <Box sx={{ textAlign: "center", mt: 4 }}>
        <Typography>No pitches found for this event.</Typography>
      </Box>
    );
  }

  return (
    <Box sx={{ p: 3 }}>
      <Stack direction="row" justifyContent="space-between" sx={{px: 2}}>
        <Typography variant="h6" sx={{ mb: 3 }}>
          Voting Results
        </Typography>
        <Button
          variant="outlined"
          style={{height: 40, width: 150}}
          onClick={() => navigate(`/votedisplay/${pairingEvent?.event?._id}`)}
        >
          Display Screen
        </Button>
      </Stack>

      <Stack spacing={2}>
        {pitches.map((pitch) => (
          <Card key={pitch._id} sx={{ p: 2 }}>
            <Stack direction="row" alignItems="center" spacing={2}>
              <Avatar
                src={pitch.profileImage}
                alt={`${pitch.firstName} ${pitch.lastName}`}
                sx={{ width: 48, height: 48 }}
              />

              <Box sx={{ flex: 1 }}>
                <Typography variant="subtitle1">
                  {pitch.firstName} {pitch.lastName}
                </Typography>
              </Box>

              <Box sx={{ textAlign: "right" }}>
                <Typography variant="body1">
                  Average Score: {pitch.avgScore?.toFixed(2) || "0.00"}
                </Typography>
                <Typography variant="body2">
                  Votes: {pitch.voteCount || 0}
                </Typography>
              </Box>
            </Stack>
          </Card>
        ))}
      </Stack>
    </Box>
  );
};

export default Votes;
